/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Footer_DisclaimerInputs */

const en_pc_footer_disclaimer = /** @type {(inputs: Pc_Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDFCraftTool.org is an independent guide to PdfCraft and is not affiliated with ArtCraft or Adobe. PdfCraft is developed by the ArtCraft team. Its source code and releases are at github.com/storytold/pdfcraft. This site is also unrelated to the PDFCraftTool/pdfcraft project on GitHub. Screenshots are taken from the PdfCraft project. Adobe and Acrobat are trademarks of Adobe Inc.`)
};

const zh_pc_footer_disclaimer = /** @type {(inputs: Pc_Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDFCraftTool.org 是关于 PdfCraft 的独立第三方指南，与 ArtCraft 及 Adobe 均无隶属关系。PdfCraft 由 ArtCraft 团队开发，源代码与发布文件位于 github.com/storytold/pdfcraft。本站与 GitHub 上的 PDFCraftTool/pdfcraft 项目也没有任何关系。页面截图来自 PdfCraft 项目。Adobe 与 Acrobat 是 Adobe Inc. 的商标。`)
};

/**
* | output |
* | --- |
* | "PDFCraftTool.org is an independent guide to PdfCraft and is not affiliated with ArtCraft or Adobe. PdfCraft is developed by the ArtCraft team. Its source cod..." |
*
* @param {Pc_Footer_DisclaimerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_footer_disclaimer = /** @type {((inputs?: Pc_Footer_DisclaimerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Footer_DisclaimerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_footer_disclaimer(inputs)
	return zh_pc_footer_disclaimer(inputs)
});
export { pc_footer_disclaimer as "pc.footer.disclaimer" }